<template>
    <SmartLinkItemComponent v-if="model" :id="model?.system?.id" :component="!model.system.workflow" >
        <div class="section-break" :class="backgroundColor" :style="backgroundImage"></div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { contentTypes, type SectionBreakModel } from '~/models';
const type = contentTypes.section_break;
const props = defineProps<{ model: SectionBreakModel }>();

// background color
const backgroundColor = computed(() => {
    switch (firstOrDefault(props?.model?.elements?.design?.value)?.codename) {
        case 'light':
            return 'bg-white';
        case 'dark':
            return 'bg-navy';
        default:
            return '';
    }
});

// background image
const backgroundImage = computed(() => {
    return props.model?.elements?.image?.value?.[0]?.url ? { 'background-image': `url(${props.model?.elements?.image?.value?.[0]?.url})` } : {};
});
</script>